module.exports = __webpack_public_path__ + "d32a8da1ef82be318bd317e54cd8139f.wav";